export enum ACTIVE_STATUS {
  INACTIVE,
  FROM_0_TO_4_HOURS,
  FROM_4_TO_10_HOURS,
  MORE_10,
}
